import { Link, useParams } from "react-router-dom";
import { usePublicSiteData } from "./PublicSiteContext";
import { toWhatsAppNumber } from "../../utils/WhatsApp";

const PublicGetInTouch = () => {
  const website = usePublicSiteData();
  const { slug } = useParams<{ slug: string }>();
  if (!website) return null;

  const base = `/${slug ?? ""}`;
  const contactPhone = website.organization.phone;
  const waNumber = toWhatsAppNumber(contactPhone);

  return (
    <section className="psite-section">
      <div className="psite-section__inner">
        <div className="psite-contact">
          <h2>Get in touch</h2>
          <p>
            Have questions or need a custom plan? Reach out to our friendly
            team.
          </p>
          <div className="psite-contact__actions">
            <Link
              className="psite-btn psite-btn--secondary"
              to={`${base}/contact`}
            >
              Contact Us
            </Link>
            {waNumber && (
              <a
                className="psite-btn psite-btn--secondary"
                href={`https://wa.me/${waNumber}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PublicGetInTouch;